import { render, staticRenderFns } from "./childNameSheet.vue?vue&type=template&id=9bb10b94&scoped=true&lang=pug"
import script from "./childNameSheet.vue?vue&type=script&lang=js"
export * from "./childNameSheet.vue?vue&type=script&lang=js"
import style0 from "./childNameSheet.vue?vue&type=style&index=0&id=9bb10b94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bb10b94",
  null
  
)

export default component.exports